import { create, EndpointCall, retrieve } from "components/http/endpoint";
import { ApiUriPrefix } from "../apiUriPrefix";

const MemberValidationApiUri = ApiUriPrefix + "member_validation";

function apiSendEmailValidationRequest(memberIdt: number, email: string): EndpointCall {
    const uri = `${MemberValidationApiUri}/${memberIdt}/email_validation_request?email=` + encodeURIComponent(email);
    return create(uri, null);
}

function apiSendPhoneValidationRequest(memberIdt: number, phoneNumber: string): EndpointCall {
    const uri = `${MemberValidationApiUri}/${memberIdt}/phone_validation_request?phoneNumber=` + encodeURIComponent(phoneNumber);
    return create(uri, null);
}

function apiGetValidationState(memberIdt: number): EndpointCall {
    const uri = `${MemberValidationApiUri}/${memberIdt}`;
    return retrieve(uri, null);
}


function apiValidateEmail(hash: string): EndpointCall {
    const uri = `${MemberValidationApiUri}/validate_email?hash=` + encodeURIComponent(hash);
    return create(uri, null);
}

function apiValidatePhone(memberIdt: number, code: string): EndpointCall {
    const uri = `${MemberValidationApiUri}/${memberIdt}/validate_phone?code=` + encodeURIComponent(code);
    return create(uri, null);
}


export {
    apiSendEmailValidationRequest,
    apiSendPhoneValidationRequest,
    apiGetValidationState,
    apiValidateEmail,
    apiValidatePhone,
}